import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function OAuthCallback() {
  const { socialLogin } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (!code || !state) {
      setError('Parametri OAuth mancanti.');
      return;
    }

    const redirect_uri = `${window.location.origin}/auth/callback`;
    const code_verifier = sessionStorage.getItem('pkce_code_verifier') || undefined;
    sessionStorage.removeItem('pkce_code_verifier');

    socialLogin(state, code, redirect_uri, code_verifier)
      .then(() => navigate('/'))
      .catch((err) => {
        const data = err.response?.data;
        // Cantiere Registrazione, Fetta 2b: email sconosciuta + registrazione
        // aperta → il backend consegna un biglietto firmato. Lo mettiamo in
        // sessione (NON nell'URL: e' un lasciapassare a tempo, fuori da
        // cronologia e log) e portiamo l'utente al form di adesione.
        if (data?.codice === 'account_non_registrato' && data?.registration_ticket) {
          sessionStorage.setItem('registration_ticket', data.registration_ticket);
          sessionStorage.setItem('registration_prefill', JSON.stringify({
            email: data.email || '',
            nome: data.nome || '',
            cognome: data.cognome || '',
          }));
          navigate('/auth/registrati');
          return;
        }
        setError(data?.error || 'Errore durante il login social.');
      });
  }, []); // eslint-disable-line

  if (error) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'var(--chip)'
      }}>
        <div style={{ textAlign: 'center', maxWidth: 400, padding: '0 16px' }}>
          <div style={{ fontSize: 14, color: 'var(--ds-danger)', marginBottom: 16 }}>{error}</div>
          <button
            onClick={() => navigate('/auth/login')}
            style={{
              padding: '9px 24px', borderRadius: 'var(--radius-base)', border: '1px solid var(--ds-border)',
              background: 'var(--ds-bg)', fontSize: 12, cursor: 'pointer',
              color: 'var(--ds-text)'
            }}
          >
            Torna al login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--chip)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div className="gradient-brand" style={{
          width: 40, height: 40, borderRadius: 'var(--radius-base)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px'
        }}>
          <span style={{ color: 'white', fontWeight: 500, fontSize: 18, fontStyle: 'italic' }}>m</span>
        </div>
        <div style={{ fontSize: 12, color: 'var(--ds-muted)' }}>Accesso in corso...</div>
      </div>
    </div>
  );
}
